<template>
  <tutorial-layout
    title="Computed Properties"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">
      In Vue.js, computed properties enable you to create a property that can be used to modify, manipulate, and display data within your components in a readable and efficient manner.

      <br/>
      You can use computed properties to calculate and display values based on a value or set of values in the data model. It can also have some custom logic that is cached based on its dependencies, meaning it doesn’t reload but does have a dependency that changes, allowing it to somewhat listen to changes and act accordingly.
    </p>

    <p slot="benefits">
      Computed properties are a vital part of Vue to understand. They are calculations that will be cached based on their dependencies and will only update when needed. They’re extremely performant when used well and extraordinarily useful. There are many large libraries that handle this kind of logic that you can now eliminate with only a few lines of code.
    </p>

    <v-card color="#f6f7ff">
      <v-card-text>
        <Fullname />
      </v-card-text>
    </v-card>
    <br/>

    <v-card color="#f6f7ff">
      <v-card-text>
        <ComputedUsage />
      </v-card-text>
    </v-card>

<br/>
    <v-card color="#f6f7ff">
      <v-card-text>
        <GetterSetter />
      </v-card-text>
    </v-card>

    <br/>
    <v-card color="#f6f7ff">
      <v-card-text>
        <ComputedWatcher />
      </v-card-text>
    </v-card>
  </tutorial-layout>
</template>

<script>
import moment from "moment";

import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";
import Fullname from "./fullname";
import ComputedUsage from "./computed-usage";
import GetterSetter from "./getter-setter";
import ComputedWatcher from "./computed-watcher.vue";
export default {
  name: "VModel",
  mixins: [uiView],
  created() {},
  data() {
    return {
    };
  },
  components: { tutorialLayout, Fullname, ComputedUsage, GetterSetter, ComputedWatcher },
  props: {},
  watch: {},
  computed: {
    referenceLinks() {
      return [
        {
          title: "Computed Properties",
          href: "https://vuejs.org/v2/guide/computed.html",
        },
        {
          title: "Basic computed props",
          href: "https://www.tutorialspoint.com/vuejs/vuejs_computed_properties.htm",
        },
        {
          title: "Computed into data variable",
          href: "https://www.codegrepper.com/code-examples/javascript/vue+js+assign+computed+into+data+varable",
        },
      ];
    },
    youtubeLinks() {
      return [
        {
          title: "Tutorial : Computed Properties",
          href: "https://www.youtube.com/embed/O14qJr5sKXo",
        },
        {
          title: "Getter Setter in Computed",
          href: "https://www.youtube.com/embed/M_wp3s5ptT4",
        },
        {
          title: "Intro to Computed Properties",
          href: "https://www.youtube.com/embed/NK-Cy4IHwI4",
        },
      ];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
</style>
